const openRegistrion = {
  methods: {
    openRegistration () {
      this.triggerClickedSignUp()
      return window.location = '/login?register=true'
    }
  }
}

export default openRegistrion